import React from "react";
import FadeInWhenVisible from "./layouts/FadeInWhenVisible";
import { FaExternalLinkAlt, FaGithub, FaPlayCircle } from "react-icons/fa";
import SectionHeading from "./layouts/SectionHeading";

const projects = [
  {
    title: "PujaPadhati – Mobile App",
    summary:
      "A spiritual mobile app featuring festivals, rituals, remedies, and search functionality. Published on the Google Play Store with active users.",
    techStack: ["React Native", "TypeScript", "Expo", "React Navigation"],
    image: "/pp-card.jpg",
    link: "https://play.google.com/store/apps/details?id=com.rahulmishra.PujaPadhati",
    video: "https://www.youtube.com/shorts/_iMcF-stVYM",
  },
  {
    title: "Satyanarayan Puja & Katha – Mobile App",
    summary: "A React Native devotional app featuring Satyanarayan Puja Vidhi, Katha, Aarti, Havan Vidhi, and Puja Samagri in Hindi, with fully offline content access.",
    techStack: ["React Native", "TypeScript", "Expo", "React Navigation"],
    image: "/satya.jpg",
    link: "https://play.google.com/store/apps/details?id=com.pujapadhati.satyanarayan",
  },
  {
    title: "PujaPadhati v2.0 – Web Application",
    live: "www.pujapadhati.com",
    summary:
      "An SEO-optimized spiritual platform with Festivals, Remedies, Dark Mode, Search, and a Play Store app (PujaPadhati).",
    techStack: ["Next.js", "TypeScript", "Tailwind CSS", "Fuse.js", "EmailJS"],
    image: "/pp-web.jpg",
    link: "https://pujapadhati.com",
    video: "https://www.youtube.com/shorts/_iMcF-stVYM",
  },
  {
    title: "Aarti Sangrah – Mobile App",
    summary:
      "A Hindu devotional app featuring Hindi Aarti lyrics, offline access, favorites, adjustable text size, temple bell and Shankh sounds, and an interactive Diya. Published on the Google Play Store.",
    techStack: ["React Native", "TypeScript", "Expo", "Expo Router"],
    image: "/aarti.jpg",
    link: "https://play.google.com/store/apps/details?id=com.pujapadhati.aartisangrah",
  },
  {
    title: "Ghaghari Dham – Official Website",
    summary:
      "A responsive official temple website showcasing Ghaghari Dham's history, spiritual significance, temple information, photo gallery, and digital support features, with a Hindi language option.",
    techStack: ["Next.js", "React", "TypeScript", "Tailwind CSS"],
    image: "/ghaghari.jpg",
    link: "https://ghagharidham.com",
  },
  {
    title: "MyTube",
    summary: "MyTube is a video-sharing application inspired by YouTube. It offers a rich media experience like video streaming.",
    techStack: ["HTML", "CSS", "Javascript"],
    image: "/mytube.png",
    link: "https://frolicking-caramel-76c661.netlify.app/",
    github: "https://github.com/Pannakbhushana/MyTube",
  },
  // {
  //   title: "PujaPadhati Version 1",
  //   summary:
  //     "A spiritual ritual platform featuring slokas, mantras, aartis, and donation capabilities. Built with a simple yet elegant UI for exploring Hindu rituals and devotional content.",
  //   techStack: ["React.js", "Chakra UI", "EmailJS"],
  //   image: "/pujapadhati.png",
  //   link: "https://puja-padhati.netlify.app",
  //   video: "https://www.youtube.com/shorts/XF7gd51ssnA",
  // },
];

const Projects = () => {
  return (
    <section id="projects" className="py-16 px-4 relative">
      <FadeInWhenVisible direction="up" animationType="scale">
        <SectionHeading>Projects</SectionHeading>
      </FadeInWhenVisible>
      <br />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {projects.map((project, i) => (
          <FadeInWhenVisible key={i} direction="up" delay={i * 0.1}>
            <div className="bg-white rounded-xl shadow-md hover:shadow-xl transition-shadow duration-300 overflow-hidden flex flex-col h-full">

              <img
                src={project.image}
                alt={project.title}
                className="w-full h-50 object-cover"
              />

              <div className="p-6 flex flex-col flex-1">

                <h3 className="text-xl font-semibold tracking-tight">
                  {project.title}
                </h3>

                {project.live && (
                  <div className="mt-2">
                    <a
                      href={project.live}
                      target="_blank"
                      className="inline-block text-sm bg-blue-50 text-blue-700 px-3 py-1 rounded-lg font-medium hover:bg-blue-100 transition"
                    >
                      Live at: {project.live}
                    </a>
                  </div>
                )}

                <p className="text-sm text-gray-600 mt-4 leading-relaxed flex-1">
                  {project.summary}
                </p>

                <div className="mt-4 flex flex-wrap gap-2">
                  {project.techStack.map((tech) => (
                    <span
                      key={tech}
                      className="text-xs px-3 py-1 bg-gray-100 text-gray-700 rounded-full border border-gray-200"
                    >
                      {tech}
                    </span>
                  ))}
                </div>

                <div className="mt-6 pt-4 border-t flex items-center gap-6">
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-sm text-blue-600 font-medium hover:underline"
                  >
                    <FaExternalLinkAlt />
                    Go Live
                  </a>

                  {project.github ? (
                    <a
                      href={project.github}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-sm text-gray-700 font-medium hover:underline"
                    >
                      <FaGithub />
                      GitHub
                    </a>
                  ) : (
                    <span className="text-sm text-gray-500 italic">
                      Source code on request
                    </span>
                  )}

                  {project.video && (
                    <a
                      href={project.video}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 text-sm text-blue-500 font-medium hover:underline"
                    >
                      <FaPlayCircle className="text-red-500" size={18} />
                      Presentation
                    </a>
                  )}
                </div>

              </div>
            </div>
          </FadeInWhenVisible>

        ))}
      </div>
    </section>
  );
};

export default Projects;
